var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "validationProviderRef",
    attrs: {
      rules: _vm.rules,
      name: _vm.nameValidation
        ? _vm.nameValidation
        : _vm.nomeAba + "/" + _vm.label,
      mode: "lazy"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var errors = ref.errors
          return [
            _c(
              "el-col",
              { class: _vm.marginLeft ? "ml-2" : "" },
              [
                _c("Label", {
                  attrs: {
                    label: _vm.label,
                    obrigatorio: _vm.obrigatorio,
                    Indice: _vm.Indice
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.options, function(option, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "flex-column gap-2" },
                    [
                      _c(
                        "div",
                        { class: index > 0 ? "mt-2" : "" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: option.disabled,
                                checked: _vm.value.includes(option.id)
                              },
                              on: {
                                change: function() {
                                  return _vm.updateValues(option)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(option.nome) +
                                  "\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                errors.length > 0
                  ? _c("span", { staticClass: "help erro" }, [
                      _vm._v("  " + _vm._s(errors[0]) + " ")
                    ])
                  : _vm._e()
              ],
              2
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e2aa301", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2aa301","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/InputCheck/InputCheck.vue
// module id = null
// module chunks = 